import React from "react";
import PropTypes from "prop-types";

const TrailerModalContent = ({ trailer_type, trailer_video_id, trailer }) => {
  let embedLink = null;

  switch (trailer_type) {
    case "youtube":
      embedLink = `https://www.youtube.com/embed/${trailer_video_id}?autoplay=1`;
      break;

    case "vimeo":
      embedLink = `https://player.vimeo.com/video/${trailer_video_id}?autoplay=1`;
      break;

    case "wistia":
      embedLink = trailer;
      break;

    case "kaltura":
      const partnerId = "2601552";
      const uiConfId = "46258051";
      const entryId = trailer_video_id;

      embedLink = `https://cdnapisec.kaltura.com/p/${partnerId}/embedPlaykitJs/uiconf_id/${uiConfId}?iframeembed=true&entry_id=${entryId}&config[playback]={"autoplay":false}`;
      break;

    default:
      break;
  }

  return (
    <>
      {embedLink ? (
        <div className="course-trailer-container">
          <iframe
            title="course-trailer"
            src={embedLink}
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen"
          />
        </div>
      ) : (
        <div className="warning">
          <p>
            Somente links do Youtube, Vimeo, Wistia ou Kaltura podem ser usados
            no momento.
          </p>
        </div>
      )}
    </>
  );
};

TrailerModalContent.defaultProps = {
  trailer: null,
  trailer_type: null,
  trailer_video_id: null,
};

TrailerModalContent.propTypes = {
  trailer: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  trailer_type: PropTypes.string,
  trailer_video_id: PropTypes.string,
};

export default TrailerModalContent;
